<template>
  <!--
          作者：luoyiming
          时间：2019-10-24
          描述：后台系统头部
      -->
  <div class="common-header">
    <div class="breadcrumb">
      <!--一般的标题显示-->
      <div class="baseInfo-left-base d-s-c">
        <span class="name">{{ menu_title }}</span>
        <!--插件切换-->
        <div class="el-tabs-container">
          <el-tabs v-model="activeValue" @tab-click="tabClick">
            <el-tab-pane :label="item.value" :name="item.key" v-for="(item, index) in tabList" :key="index"></el-tab-pane>
          </el-tabs>
        </div>
      </div>

      <div class="header-navbar">
        <div class="header-navbar-icon" v-for="(item, index) in webindexList" :key="index">
          <div style="display:flex; justify-content: center;align-items: center;text-align: center;"
            @click="goweb(item.url)">
            <img src="../../assets/img/keshihua.png"
              style="width:20px;height:20px; border-radius: 50%; padding:1px;margin-right:5px;border:1px solid #ccc;"
              alt="">
            <span>{{ item.name }}</span>
          </div>
        </div>
        <!-- <div class="header-navbar-icon">
          <div style="display:flex; justify-content: center;align-items: center;text-align: center;">
            <img src="../../assets/img/keshihua.png" style="width:20px;height:20px; border-radius: 50%; padding:1px;margin-right:5px;border:1px solid #ccc;" alt="">
            <span>数据大屏</span>
          </div>
        </div> -->
        <div class="header-navbar-icon">
          <span class="gray">当前版本：{{ baseInfo.version }}</span>
        </div>
        <div class="header-navbar-icon">
          <span class="ml4 icon iconfont icon-geren9"></span>
          <span class="text ml4 blue">，欢迎您！</span>
          <!-- {{ baseInfo.user.user_name }} -->
        </div>
        <div class="header-navbar-icon">
          <el-popover placement="bottom" trigger="click">
            <template slot="reference">
              <el-badge is-dot class="item" style="display: flex;">
                <span style="font-size: 160%;" class="icontool el-icon-bell el-dropdown-selfdefine"></span>
              </el-badge>
            </template>
            <ul>
              <li style='line-height: 36px;  display: flex;align-items: center; padding: 0 10px;color:rgb(153,153,153)'
                v-for="(item, index) in gridData" :key="index" :class="hoveredRow === index ? 'hovered-row' : ''"
                @mouseover="hoveredRow = index" @mouseout="hoveredRow = null" @click="jumpclick(item)">
                <span style="font-size: 100%;color:orange;margin-right:5px" class="icontool el-icon-document"></span>
                <div>
                  您有
                  <span style='color:red;padding:0 2px'>{{ item.count }}</span>{{ item.value }}
                </div>
              </li>
            </ul>

          </el-popover>
        </div>
        <!--  -->
        <div class="header-navbar-icon">
          <span class="gray">|</span>
        </div>
        <div class="header-navbar-icon" @click="passwordFunc()">
          <span class="text">修改密码</span>
        </div>
        <div class="header-navbar-icon login-out" @click="login_out()">
          <span class="icon iconfont icon-tuichu"></span>
          <span class="text ml4">退出</span>
        </div>
      </div>
    </div>
    <!-- 弹框 -->
    <!-- <dialog-box :visible="dialogVisible" :title="dialogTitle" :show-close="showclose" :width="dialogWidth"
      :message="dialogMessage" @confirm="handleConfirm" @cancel="handleCancel" @before-close="beforeClose"
      ref="showvisible"></dialog-box> -->
    <!--修改密码-->
    <UpdatePassword v-if="is_password" @close="closeFunc"></UpdatePassword>
  </div>
</template>

<script>
//
let socket = "";
import bus from "@/utils/eventBus.js";
import IndexApi from "@/api/index.js";
import AuthApi from "@/api/auth.js";
import UserApi from "@/api/user.js";
import DialogBox from "@/components/dialog.vue";
import {
  setCookie,
  delCookie,
  getCookie,
  deleteSessionStorage
} from "@/utils/base.js";
import store from "@/store";
import UpdatePassword from "./part/UpdatePassword.vue";
export default {
  components: {
    UpdatePassword,
    DialogBox
  },
  data() {
    return {
      /*菜单名称*/
      menu_title: "菜单",
      /*切换菜单*/
      tabList: [],
      /*切换选中*/
      activeValue: 0,
      /*是否修改密码*/
      is_password: false,
      /*tab切换类别*/
      tab_type: "",
      webindexList: {},
      audioUrl: "",
      dialogVisible: false,
      showclose: false,
      dialogTitle: "Hello，管理员！",
      dialogWidth: "30%",
      dialogMessage: "常回来看看~",
      hoveredRow: null,
      gridData: []
    };
  },
  inject: ["baseInfo"],
  created() {
    this.dialogVisible = true;
    /*监听菜单传过来的值*/
    bus.$on("menuName", res => {
      this.menu_title = res;
    });

    /*监听传插件的值*/
    bus.$on("tabData", res => {
      this.tabList = res.list;
      this.activeValue = res.active;
      this.tab_type = res.tab_type;
    });

    //发送给其它组件头部加载完成
    bus.$emit("headLoad", true);
    this.webindex();
    this.getheadtotal();
  },
  beforeDestroy() {
    bus.$off("menuName");
    bus.$off("tabData");
  },
  mounted() {
    this.getwobsocked();
  },
  methods: {
    jumpclick(item) {
      // console.log("==========item", item);
      if (item.type == 1) {
        this.$router.push("/order/order/index");
      } else if (item.type == 2) {
        this.$router.push("/order/refund/index");
      } else if (item.type == 3) {
        this.$router.push("/order/callmsg/index");
      }
    },
    /*获取总数据 */
    getheadtotal() {
      let self = this;

      IndexApi.remind({}, true)
        .then(res => {
          self.loading = false;
          if (res.code == 1) {
            self.gridData = res.data;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
    tableRowClassName({ row, rowIndex }) {
      console.log("===========", rowIndex);
      if (rowIndex % 2 === 0) {
        return "background-color: lightgray;";
      } else {
        return "background-color: pink;";
      }
    },
    // =====================
    handleConfirm() {
      // 处理确定按钮
      // this.dialogVisible = false;
      this.$refs.showvisible._data.internalVisible = false;
    },
    handleCancel() {
      // 处理取消按钮的逻辑
      this.dialogVisible = false;
    },
    beforeClose(done) {
      // 处理关闭对话框的逻辑
      done();
    },
    /*获取状态 发送心跳包 */
    postbindClient(client) {
      let self = this;
      let client_id = client.client_id;
      IndexApi.postbindClient({ client_id: client_id }, true)
        .then(res => {
          self.loading = false;
          if (res.code == 1) {
            self.sendPing();
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*发送心跳包 */
    sendPing() {
      setInterval(() => {
        if (localStorage.getItem("user_id")) {
          socket.send(
            JSON.stringify({
              type: "ping",
              user_id: localStorage.getItem("user_id")
            })
          );
        }
      }, 5000);
    },
    // 建立WebSocket连接
    getwobsocked() {
      socket = new WebSocket("wss://pangmi.rchz.top/socket");
      const connect = () => {
        socket.addEventListener("open", event => {
          // console.log("连接已建立");
          // this.getbindClient();
        });

        socket.addEventListener("message", event => {
          // console.log("接收到消息:", JSON.parse(event.data));
          let client = JSON.parse(event.data);
          if (client.type == "init") {
            this.postbindClient(client);
          } else if (client.type == "message") {
            this.audioUrl = client.data.musicUrl;
            // this.dialogMessage = client.data.msg;
            this.$notify({
              title: "提醒",
              message: client.data.msg,
              type: "success"
            });

            // this.dialogVisible = true;
            // 播放音频
            const audio = new Audio(client.data.musicUrl);
            audio.play();
            // setTimeout(()=>{

            // },3000)
          }
        });

        socket.addEventListener("close", event => {
          // console.log("连接已关闭");
          connect();
        });
      };
      connect();
    },
    // =====================================
    webindex() {
      // UserApi.webindex({}, true)
      //   .then(data => {
      //     // console.log("=======data", data);
      //     this.webindexList = data.data;
      //     //  window.location.href = res.data.url;
      //   })
      //   .catch(error => { });
    },
    goweb(url) {
      // window.location.href = url;
      window.open(url, "_blank");
    },
    /*退出登录*/
    login_out() {
      this.$confirm("此操作将退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          UserApi.loginOut({}, true)
            .then(data => {
              /*删除登录状态*/
              delCookie("isLogin");
              delCookie("shoptoken");
              /*删除基本信息*/
              delCookie("baseInfo");
              /*删除用户菜单*/
              deleteSessionStorage("rolelist");
              /*删除用户权限*/
              deleteSessionStorage("authlist");
              /*返回登录页*/
              this.$router.replace({
                path: "/login"
              });
              /*删除stores数据*/
              this.$store.commit("user/setState", {
                key: "roles",
                val: null
              });
              /*刷新页面*/
              location.reload();
            })
            .catch(error => { });
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消退出'
          // });
        });
    },

    /*点击跳转*/
    tabClick(e) {
      /*分销*/
      if (this.tab_type == "agent") {
        this.$router.push({
          path: "/plus/agent/index",
          query: {
            type: e.name
          }
        });
      }
      /*优惠券*/
      if (this.tab_type == "coupon") {
        this.$router.push({
          path: "/plus/coupon/index",
          query: {
            type: e.name
          }
        });
      }
      /*积分商城*/
      if (this.tab_type == "points") {
        this.$router.push({
          path: "/plus/points/index",
          query: {
            type: e.name
          }
        });
      }
      /* 现时秒杀*/
      if (this.tab_type == "seckill") {
        this.$router.push({
          path: "/plus/seckill/index",
          query: {
            type: e.name
          }
        });
      }
      /* 限时拼团*/
      if (this.tab_type == "assemble") {
        this.$router.push({
          path: "/plus/assemble/index",
          query: {
            type: e.name
          }
        });
      }
      /* 砍价*/
      if (this.tab_type == "bargain") {
        this.$router.push({
          path: "/plus/bargain/index",
          query: {
            type: e.name
          }
        });
      }
      /*门店*/
      if (this.tab_type == "store") {
        this.$router.push({
          path: "/store/index",
          query: {
            type: e.name
          }
        });
      }
      /*app设置*/
      if (this.tab_type == "appopen") {
        this.$router.push({
          path: "/appsetting/appopen/event",
          query: {
            type: e.name
          }
        });
      }
      bus.$emit("activeValue", this.activeValue);
    },

    /*修改密码*/
    passwordFunc() {
      this.is_password = true;
    },

    /*关闭修改密码*/
    closeFunc() {
      this.is_password = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.hovered-row {
  background: #e6f7dd;
}

.common-header .el-tabs__nav-wrap::after {
  display: none;
}

.common-header .el-tabs-container {
  margin-left: 20px;
  padding-left: 20px;
  border-left: 1px solid #eeeeee;
}

.common-header .el-tabs__header {
  margin-bottom: 0;
}

.login-out .icon-tuichu {
  color: red;
}

.header-navbar-icon .icon-geren9 {
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Head.vue